import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import App from "App";
import { store, persistor, history } from "./store";

import "styles/main.scss";
import "styles/themes/bibank/variables/_figma-variables.css";

/* eslint-disable react/jsx-filename-extension */
window.startApp = () => {
    const container = document.getElementById("root");
    const root = createRoot(container);

    root.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App history={history} />
            </PersistGate>
        </Provider>,
    );
};
/* eslint-enable react/jsx-filename-extension */

// Phonegap app start in ondeviceready inside index.js
if (!window.cordova) {
    window.startApp();
}
